import type { ReactNode } from 'react';
import type { OrderStatus, TripStatus } from '@kmdx/contracts';
import { cn } from '@/lib/cn';
import { ORDER_STATUS_BG, TRIP_STATUS_BG } from '@/i18n';
import { ORDER_STATUS_TONE, TRIP_STATUS_TONE } from '@/domain/orderStatus';

export type Tone = 'neutral' | 'info' | 'accent' | 'ok' | 'warn' | 'danger';

const TONES: Record<Tone, string> = {
  neutral: 'bg-raised text-ink-dim border-line-strong',
  info: 'bg-info-soft text-info border-info/40',
  accent: 'bg-accent-soft text-accent border-accent/40',
  ok: 'bg-ok-soft text-ok border-ok/40',
  warn: 'bg-warn-soft text-warn border-warn/40',
  danger: 'bg-danger-soft text-danger border-danger/40',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
  title,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[11px] font-medium leading-4',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

/**
 * Състоянието на заявка и на курс се чете десетки пъти на час — цветът е
 * семантичен и НЕ е акцентът на марката, за да не се слеят „важно" и „спешно".
 */
export function StatusPill({
  status,
  kind = 'order',
  className,
}: {
  status: OrderStatus | TripStatus;
  kind?: 'order' | 'trip';
  className?: string;
}) {
  if (kind === 'trip') {
    const s = status as TripStatus;
    return (
      <Badge tone={TRIP_STATUS_TONE[s]} className={className}>
        {TRIP_STATUS_BG[s]}
      </Badge>
    );
  }
  const s = status as OrderStatus;
  return (
    <Badge tone={ORDER_STATUS_TONE[s]} className={className}>
      {ORDER_STATUS_BG[s]}
    </Badge>
  );
}
